import type { TemplateCategory, TemplateDefinition } from "./types";
import template1 from "./thumbnails/template-1.png";
import template2 from "./thumbnails/template-2.png";

export const TEMPLATES: TemplateDefinition[] = [
  {
    id: "funeral_1",
    thumbnail_url: template1,
    name: "Template 1",
    description: "The original memorial layout",
    category: "funeral",
    layoutDescription:
      "Stream video on the left, donation widget on the right. Obituary, Memories, Donations, and Downloads tabs below the video.",
  },
  {
    id: "funeral_2",
    thumbnail_url: template2,
    name: "Template 2",
    description:
      "Full-screen hero header with stream video above tabbed content",
    category: "funeral",
    layoutDescription:
      "Full-width hero banner (name, portrait, dates). Stream video below the header. Underline tab bar: Obituary, Memories, and Admin.",
  },

  {
    id: "funeral_home_1",
    thumbnail_url: template1,
    name: "Branded Template",
    description: "Memorial page branded with the funeral home's own colors",
    category: "funeral_home",
    layoutDescription:
      "Funeral home logo and colors in the header. Stream video, register banner, Obituary and Memories tabs below.",
  },

  {
    id: "conference_1",
    name: "Classic Conference",
    description: "The original conference layout",
    category: "conference",
    layoutDescription:
      "Stream video on the left (⅔ width), live chat panel on the right (⅓ width). Service details displayed below.",
  },

  {
    id: "church_1",
    name: "Classic Church",
    description: "The original church layout",
    category: "church",
    layoutDescription:
      "Stream video on the left (⅔ width), live chat panel on the right (⅓ width). Service details displayed below.",
  },
];

export function getServiceCategory(serviceType: string): TemplateCategory {
  const s = serviceType?.toLowerCase() ?? "";
  if (s === "funeral_home") return "funeral_home";
  if (s === "funeral") return "funeral";
  if (s === "conference") return "conference";
  if (s === "church") return "church";
  return "funeral";
}

export function getTemplatesForService(
  serviceType: string,
): TemplateDefinition[] {
  const category = getServiceCategory(serviceType);
  return TEMPLATES.filter((t) => t.category === category);
}

export function getDefaultTemplateId(serviceType: string): string {
  return getTemplatesForService(serviceType)[0]?.id ?? "funeral_1";
}
